import getApiClient from '@/plugins/api'

//const moment = require('moment')

export default {
  save: function () {
    const api = getApiClient(this.$store)

    this.$store.commit('startLoading')
    this.resetErrors()

    let endpoint = 'posts'
    let method = 'post'
    let extraHeaders = {}

    if (this.post.id) {
      endpoint = `posts/${this.post.id}`
      method = 'patch'
      extraHeaders = {
        'Content-Type': 'application/merge-patch+json'
      }
    }

    let postData = this.post

    if (!postData.showFrom) {
      postData.showFrom = null
    }

    if (!postData.showUntil) {
      postData.showUntil = null
    }

    api[method](endpoint, postData, {headers: extraHeaders})
      .then(() => {
        this.error = false
        this.success = true
      })
      .catch(error => {
        this.error = true
        this.success = false
        const violations = error.response.data?.violations ?? []

        violations.forEach((violation) => {
          this.errors[violation.propertyPath] = violation.message
        })
      })
      .finally(() => {
        this.$store.commit('stopLoading')
      })
  },

  loadPost() {
    if (this.$route.params.id) {
      const api = getApiClient(this.$store)

      this.$store.commit('startLoading')
      api.get(`/posts/${this.$route.params.id}`)
        .then(result => {
          this.post = result.data
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.$store.commit('stopLoading')
        })
    }
  },

  parseDate(dateString, format) {
    return new Date(dateString)
  },

  resetErrors() {
    this.errors = {
      title: null,
      showFrom: null,
      showUntil: null,
      body: null
    }
  }
}
